// extracted by mini-css-extract-plugin
export default {"toggle":"Switch_toggle__7BucZ","active":"Switch_active__-7rZ7","disabled":"Switch_disabled__GyvHZ","check":"Switch_check__kCoJ4","spinner":"Switch_spinner__fy-yc"};